<template>
  <el-dialog
    :title="title"
    :visible="isVisible"
    :width="widthInner"
    append-to-body
    :before-close="beforeClose"
    :close-on-click-modal="closeOnMaskClick"
    @close="onClose"
  >
    <slot name="title" slot="title" />
    <slot />
    <slot name="footer" slot="footer" />
  </el-dialog>
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  model: {
    prop: 'isVisible',
    event: 'change',
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '50%',
    },
    wide: {
      type: Boolean,
      default: false,
    },
    beforeClose: {
      type: Function,
      default: undefined,
    },
    closeOnMaskClick: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const widthInner = computed(() => {
      if (props.wide) {
        return '80%'
      } else {
        return props.width
      }
    })

    const close = () => {
      emit('close')
    }

    const onClose = () => {
      emit('change', false)
      emit('close')
    }
    return {
      close,
      onClose,
      widthInner,
    }
  },
}
</script>
